export enum TIME_PICKER_TYPE {
    DIGITAL = 'DIGITAL',
    ANALOG = 'ANALOG'
};

export enum CONTENT_TYPE {
  ABOUT_US = "about-us",
  TERMS_AND_CONDITION = "terms-and-conditions",
  PRIVACY_POLICY = "privacy-policy",
};